// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 19"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M17.835 17.29l-4.975-4.974c1.097-1.28 1.733-2.936 1.733-4.754A7.312 7.312 0 007.281.25C3.242.25 0 3.524 0 7.563c0 4.038 3.274 7.312 7.28 7.312a7.274 7.274 0 004.754-1.763l4.975 4.975a.71.71 0 00.429.163.56.56 0 00.397-.165.559.559 0 000-.795zM7.313 13.75a6.176 6.176 0 01-6.188-6.188 6.176 6.176 0 016.188-6.187A6.156 6.156 0 0113.5 7.563a6.176 6.176 0 01-6.187 6.187z" />
        </svg>
    );
};

export default React.memo(Search);
